import * as t from 'io-ts';
import { False, True, UUID } from '@thingos/io-ts-shared';
import { TagInfo, TemplateInfo, UserInfo } from '../models';
const CompanyBaseInfo = t.type({
    id: UUID,
    name: t.string,
    highlightColor: t.string,
    companyLogo: t.string,
    templates: t.array(TemplateInfo),
    tags: t.array(TagInfo),
});
export const CompanyInfo = t.intersection([
    CompanyBaseInfo,
    t.union([
        t.type({ isCompanyAdmin: False }),
        t.type({
            isCompanyAdmin: True,
            users: t.array(UserInfo),
        }),
    ]),
]);
export const CompanyAdminInfo = t.intersection([
    CompanyBaseInfo,
    t.type({
        isCompanyAdmin: True,
        users: t.array(UserInfo),
    }),
]);
export const GetCompaniesResponse = t.array(CompanyInfo);
export const PostCompanyRequest = t.type({
    name: t.string,
    adminMail: t.string,
    highlightColor: t.string,
});
export const AddUserToCompanyRequest = t.type({
    companyId: t.string,
    email: t.string,
    admin: t.boolean,
});
export const ChangeUserRoleRequest = t.type({
    companyId: t.string,
    userId: t.string,
    admin: t.boolean,
});
export const RemoveUserFromCompanyRequest = t.type({
    companyId: t.string,
    userId: t.string,
});
export const UpdateCompanyRequest = t.type({
    companyId: t.string,
    name: t.string,
    highlightColor: t.string,
});
export const DeleteCompanyRequest = t.type({
    companyId: t.string,
    password: t.string,
});
export const CompanyLogoUpload = t.type({
    companyId: t.string,
    file: t.unknown,
});
export const CompanyLogoUploadResponse = t.type({
    companyLogo: t.string,
});
//# sourceMappingURL=companies.js.map